import React, {PureComponent, PropTypes} from 'react';
import Modal from 'react-modal';
import cx from 'classnames';
import braintree from 'braintree-web';

import style from './pay.module.css';
import modalStyle from '../modal.module.css';

class Pay extends PureComponent {

    static propTypes = {
        onClose: PropTypes.func,
        open: PropTypes.bool,
        teamId: PropTypes.number,
        tournamentId: PropTypes.number,
        address: PropTypes.string,
        name: PropTypes.string,
        braintreeToken: PropTypes.string,
        price: PropTypes.number
    };

    constructor(props) {
        super(props);

        this._selects = [];
        this.state = {};
    }

    _resetState() {
        this.setState({
            error: '',
            loading: false
        });
    }

    _submitForm = () => {

        if (this.state.loading || !this._paymentNone) {
            return;
        }

        if (!this._addressInput.value) {
            return this.setState({
                error: Exanimo.trans('missing_address')
            });
        }

        if (!this._nameInput.value) {
            return this.setState({
                error: Exanimo.trans('missing_name')
            });
        }

        this.setState({
            error: '',
            loading: true
        });

        fetch(`/tournament/pay`, {
            credentials: 'same-origin',
            method: 'post',
            body: JSON.stringify({
                tournament_id: this.props.tournamentId,
                team_id: this.props.teamId,
                nonce: this._paymentNone,
                address: this._addressInput.value,
                name: this._nameInput.value
            }),
            headers:{'X-CSRF-TOKEN': Exanimo.CSRF}
        }).then((response) => {

            if (response.status !== 200) {
                throw new Error(Exanimo.trans('request_failed'));
            }

            return response.json();
        }).then((data) => {
            if (data.ok) {
                document.location.reload(true);
            } else {
                throw new Error(data.error);
            }
        }).catch((err) => {
            this.setState({
                loading: false,
                error: err.message
            });
        });
    }

    componentWillReceiveProps(props) {
        if (props.init) {
            this._resetState();
        }
    }

    _initBraintree() {
        this._paymentNone = '';

        braintree.setup(this.props.braintreeToken, "dropin", {
            container: "braintree-container",
            onPaymentMethodReceived: (method) => {
                this._paymentNone = method.nonce;
                this._submitForm();
            },

            onError(err) {
                console.log(err);
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this._initBraintree();
        }
    }

    componentDidMount() {
        this._initBraintree();
    }

    _onChangeTeam = (e) => {
        const team = parseInt(e.target.value, 10);

        this.setState({
            teamSelected: team
        });
    }

    render() {

        const customStyles = {
            overlay : {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                zIndex: 2
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                backgroundColor       : '#F1F1F1',
                color                 : '#333333',
                padding               : '0'
            }
        };

        const error = (this.state.error) ? <div className={modalStyle.error}>{this.state.error}</div> : '';
        const saveButtonText = (this.state.loading) ? '. . .' :  Exanimo.trans('pay');
        const buttonClasses = cx(modalStyle.button, style.button);

        return (
            <Modal
                isOpen={this.props.open}
                onRequestClose={this.props.onClose}
                contentLabel="Pay"
                style={customStyles}
            >
                <div className={style.container}>
                    <a href="" onClick={this.props.onClose} className={modalStyle.close}/>

                    <form className={style.content}>
                        {error}
                        <p className={modalStyle.subtitle}>{Exanimo.trans('name_surname')} <span className={modalStyle.required}>*</span></p>
                        <input ref={(input) => {this._nameInput = input}} className={style.input} defaultValue={this.props.name}/>

                        <p className={modalStyle.subtitle}>{Exanimo.trans('address')} <span className={style.required}>*</span></p>
                        <input ref={(input) => {this._addressInput = input}} className={style.input} defaultValue={this.props.address}/>

                        <div id="braintree-container" className={style.braintreeContainer}/>

                        <div className={style.actionContainer}>
                            <span className={style.price}>{Exanimo.trans('sum')} {this.props.price}€</span>
                            <input type="submit" className={buttonClasses} value={saveButtonText}/>
                        </div>
                    </form>
                </div>
            </Modal>);
    }
}

export default Pay;